{
  "advancededitor": {
    "Add entry": "Add entry",
    "Duplicate": "Duplicate",
    "Image attached": "Image attached",
    "Inherit from wheel": "Inherit from wheel",
    "Not shown on the wheel": "Not shown on the wheel",
    "Popup message": "Popup message",
    "Shown on the wheel": "Shown on the wheel",
    "Weight": "Weight"
  },
  "app": {
    "Ads": "Ads",
    "Click here to report an inappropriate ad": "Click here to report an inappropriate ad.",
    "Click the Language menu": "Click the menu in the upper right to switch to English",
    "Close ad": "Close ad",
    "Common questions about using the random name picker wheel": "Common questions about using the random name picker wheel",
    "Copy this wheel": "Copy this wheel",
    "Create your own": "Create your own",
    "Error": "Error",
    "Free and easy to use": "Free and easy to use spinner. Used by teachers and for raffles. Enter names and spin the wheel to pick a random winner. Customize look and feel, save and share wheels.",
    "Frequently Asked Questions": "Frequently Asked Questions",
    "It looks like you are using Internet Explorer": "It looks like you are using Internet Explorer. That browser will soon stop receiving security updates from Microsoft. This puts you and us at great risk.\nSoon you will not be able to use this website with Internet Explorer. Please download another browser by doing a web search for \"download web browser\". Any modern browser will do, for example Chrome, Firefox, or Edge.",
    "Loaded default names and options": "Loaded default names and options",
    "Random name picker": "Random name picker",
    "Removed": "Removed {name}",
    "Removing winner in": "Removing winner in {seconds} seconds",
    "Report bad ad": "Report bad ad",
    "Warning": "Warning",
    "We try to display only legitimate and honest ads": "We try to display only legitimate and honest ads.",
    "authError": "That didn't work. Please try again and you will be prompted to sign in. If it still doesn't work, try these things: refresh the page with Ctrl+Shift+R (Windows, Linux, Chromebook) or Command+Shift+R (Mac), turn off your ad-blocker, turn off your anti-virus software."
  },
  "appInfo": {
    "Terms of service": "Terms & conditions",
    "Version": "Version"
  },
  "faq": {
    "How do I use this app": "How do I use this app",
    "This app lets you spin a wheel": "This app lets you spin a wheel",
    "Can I save my wheel": "Can I save my wheel",
    "Yes, if you create an account": "Yes, if you create an account",
    "Is this app free": "Is this app free",
    "Yes, this app is completely free": "Yes, this app is completely free"
  },
  "common": {
    "Cancel": "Cancel",
    "Close": "Close",
    "Continue": "Continue",
    "Customize": "Customize",
    "Delete": "Delete",
    "Edit description": "Edit description",
    "Edit title": "Edit title",
    "Edit title and description": "Edit title and description",
    "If you dont see a Google login button below": "If you don't see a Google login button below, it's probably because you are using an ad-blocker that mistakenly thinks the button is an ad.",
    "Link Google Account": "Link Google Account",
    "Link Google Sheet": "Link Google Sheet",
    "Link Google Spreadsheet": "Link Google Spreadsheet",
    "Move down": "Move down",
    "Move up": "Move up",
    "My account": "My account",
    "Sign in with Google": "Sign in with Google",
    "Sign in": "Sign in",
    "Create account": "Create account",
    "or": "or",
    "Email": "Email",
    "Password": "Password",
    "Display name": "Display name",
    "Display name is required": "Display name is required",
    "Sign in instead": "Sign in instead",
    "OK": "OK",
    "Open": "Open",
    "Privacy policy": "Privacy policy",
    "Report offensive content": "Report offensive content",
    "Save": "Save",
    "Use this in the classroom": "Use this in the classroom",
    "We have a winner!": "We have a winner!",
    "Wheel description": "Wheel description",
    "Wheel title": "Wheel title",
    "Max": "Max"
  },
  "nameTabs": {
    "Clear the list": "Clear the list",
    "Entries": "Entries",
    "Hide": "Hide",
    "Results": "Results"
  },
  "opendialog": {
    "Are you sure": "Are you sure you want to delete \"{wheelTitle}\"? This action cannot be undone.",
    "Delete wheel": "Delete wheel",
    "No wheels found": "No wheels found in your account. Try saving a wheel!",
    "Open wheel": "Open wheel",
    "To open wheels": "To open wheels you need to sign in to an account.\nPlease choose your sign-in method below."
  },
  "optionsdialog": {
    "After spin": "After spin",
    "All names in the text-box": "All names in the text-box have the same chance of winning, regardless of this value.",
    "Animate winning entry": "Animate winning entry",
    "Appearance": "Appearance",
    "Apply a theme": "Apply a theme",
    "Auto-remove winner after 5 seconds": "Auto-remove winner after 5 seconds",
    "Background color": "Page background color",
    "Center text": "Center text",
    "Colors": "Colors",
    "Colors tooltip": "Click the color swatches to modify them",
    "Contours": "Contours",
    "Custom": "Custom",
    "Customize colors": "Customize colors",
    "Disabled because the entries": "Disabled because the entries have unequal weights",
    "Display Hide button": "Display the \"Hide\" button",
    "Display Remove button": "Display the \"Remove\" button",
    "Display duplicates": "Display duplicates",
    "Display every entry": "Display every entry in the textbox as an entry on the wheel, even duplicates",
    "Display popup with message:": "Display popup with message:",
    "During spin": "During spin",
    "From Gallery": "From gallery",
    "Image": "Image",
    "Image in the center of the wheel": "Image at the center of the wheel",
    "Image size": "Image size",
    "Launch confetti": "Launch confetti",
    "Max names on wheel": "Max number of names visible on the wheel",
    "No": "No",
    "One color": "One color per section",
    "Options": "Options",
    "Pick category": "Pick category",
    "Pick theme": "Pick theme",
    "Play click sound when the winner is removed": "Play a click sound when the winner is removed",
    "Remove image": "Remove the image",
    "Select a gallery picture": "Select a gallery picture",
    "Show title": "Show title",
    "Sound": "Sound",
    "Spin slowly": "Spin slowly",
    "Spin time (seconds)": "Spin time (seconds)",
    "Text": "Text",
    "Upload image": "Upload image",
    "Volume": "Volume",
    "Wheel background image": "Wheel background image",
    "Yes": "Yes",
    "Your image has been uploaded": "Your image '{fileName}' has been uploaded successfully. Would you like to use the prominent colors from this image for the sectors of your wheel?",
    "Advanced mode is enabled": "Advanced mode is enabled",
    "Sounds": "Sounds",
    "Behavior": "Behavior",
    "Effects": "Effects",
    "Color": "Color"
  },
  "profiledropdown": {
    "Are you sure you want to delete your account": "Are you sure you want to delete your account and all your saved wheels? This action cannot be undone.",
    "Delete account": "Delete account",
    "Delete my account": "Delete my account",
    "Export my data": "Export my data",
    "Sign out": "Sign out",
    "Signed in as": "Signed in as {name}",
    "Anonymous user": "Anonymous user",
    "Welcome new user": "Welcome to Spin the Names! Your account has been created.",
    "Signed in success": "Successfully signed in!",
    "Signed out": "Signed out",
    "Your account and your saved wheels have been deleted": "Your account and your saved wheels have been deleted"
  },
  "savedialog": {
    "Save as": "Save as",
    "Save wheel": "Save wheel",
    "Select a wheel": "Select a wheel",
    "Sorry, too many images": "Sorry, this wheel has too many images to be saved in the database. Reduce the number of images and try saving again.",
    "To save wheels": "To save wheels you need to sign in to an account.\nPlease choose your sign-in method below.",
    "Wheel saved successfully": "Wheel \"{wheelTitle}\" saved successfully",
    "You will always be able to access": "You will always be able to access your saved wheels so long as you open or save any wheel at least once every 12 months.",
    "Your existing wheels": "Your existing wheels"
  },
  "sharedialog": {
    "Copy link": "Copy link",
    "Created": "Created",
    "If you continue": "If you continue, you will create a public link to your current wheel, including its names, colors and settings.",
    "Last viewed": "Last viewed",
    "Link": "Link",
    "Link copied to the clipboard": "Link copied to the clipboard",
    "Link to this wheel": "Link to this wheel with current names, colors and settings:",
    "My shared wheels": "My shared wheels",
    "No wheels found": "No shared wheels found in your account. Try sharing a wheel!",
    "See my shared wheels": "See my shared wheels",
    "Shareable link": "Shareable link",
    "Show title to people": "Show the title to people who use your shared link",
    "Sorry, too many images": "Sorry, this wheel has too many images to be shared. Reduce the number of images and try saving again.",
    "They should be able to spin the wheel and": "They should be able to spin the wheel and make a copy of it",
    "They should only be able to spin the wheel": "They should only be able to spin the wheel",
    "This link will work for anyone": "This link will work for anyone and you can share it by email, website, social media, etc. Unused links will be deleted after 365 days.",
    "Visits": "Views",
    "We want this website to be safe place for everyone": "We want this website to be a safe place for everyone. Wheels that aren't family-friendly and that violate the terms of service will be deleted.",
    "What should a person be able to do": "What should a person be able to do when they use your shared link?"
  },
  "sheetdialog": {
    "Column": "Column",
    "First row": "First row",
    "Is a header and should not be imported": "Is a header and should not be imported",
    "Link sheet": "Link sheet",
    "Select a column": "Select a column",
    "Select a tab": "Select a tab",
    "Selected spreadsheet": "Selected spreadsheet",
    "Tab": "Tab",
    "To import sheets": "To import sheets you need to log in to your Google account. Why? Google needs to know who you are, so they can let you pick one of your spreadsheets.",
    "When you link a spreadsheet": "When you link a spreadsheet, the wheel will contain the same entries as the spreadsheet. If rows are added or deleted in the spreadsheet, entries are automatically added to or removed from the wheel. The connection will close after one hour.",
    "added": "{entry} added",
    "entries added": "{count} entries added"
  },
  "sounds": {
    "Alarm clock": "Alarm clock",
    "Angel choir": "Angel choir",
    "Announcement bell": "Announcement bell",
    "Applause": "Loud applause",
    "Basketball buzzer": "Basketball buzzer",
    "Bell ringing": "Bell ringing",
    "Bird chirps": "Bird chirps",
    "Boing": "Boing",
    "Boing 2": "Boing 2",
    "Carnival shout": "Carnival shout",
    "Cartoon whistle": "Cartoon whistle",
    "Cat meow": "Cat meow",
    "Childrens hooray": "Children's hooray",
    "Cinematic drum impact": "Cinematic drum impact",
    "Cinematic music": "Cinematic music",
    "Correct answer ding": "Correct answer ding",
    "Crash": "Crash",
    "Cymbals": "Cymbals",
    "Dog bark": "Dog bark",
    "Drum roll": "Drum roll",
    "Easy listening": "Easy listening",
    "Evil laugh": "Evil laugh",
    "Fanfare": "Fanfare",
    "Fireworks": "Fireworks",
    "Game win ding": "Game win ding",
    "Ghost": "Ghost",
    "Hooray": "Hooray",
    "Horror scream": "Horror scream",
    "Horse": "Horse",
    "Joke punchline": "Joke punchline",
    "Lion roar": "Lion roar",
    "Lost game": "Lost game",
    "Microwave ding": "Microwave ding",
    "Military trumpet": "Military trumpet",
    "Mystery bell": "Mystery bell",
    "No sound": "No sound",
    "Notification bell": "Notification bell",
    "Old phone ringing": "Old phone ringing",
    "Pan flute": "Pan flute",
    "Pop music": "Pop music",
    "Random 8-Bit": "Random 8-Bit",
    "Random ballroom dancing": "Random ballroom dancing",
    "Random cinematic music": "Random cinematic music",
    "Random dance & techno": "Random dance & techno",
    "Random disco": "Random disco",
    "Random easy listening": "Random easy listening",
    "Random electronica": "Random electronica",
    "Random folk music": "Random folk music",
    "Random funk": "Random funk",
    "Random hip hop": "Random hip hop",
    "Random music": "Random music",
    "Random polka": "Random polka",
    "Random pop music": "Random pop music",
    "Random reggae & reggaeton": "Random reggae & reggaeton",
    "Random retro-rock": "Random retro-rock",
    "Random rock music": "Random rock music",
    "Random rockabilly": "Random rockabilly",
    "Random silent film score": "Random silent film score",
    "Random winter holidays": "Random winter holiday music",
    "Random world music": "Random world music",
    "Read out the winning name": "Read out the winning name",
    "Read out the winning name (option 1)": "Read out the winning name (option 1)",
    "Read out the winning name (option 2)": "Read out the winning name (option 2)",
    "Referee whistle": "Referee whistle",
    "Rock music": "Rock music",
    "Sad trombone": "Sad trombone",
    "Silent film score": "Silent film score",
    "Sound effects": "Sound effects",
    "Subdued applause": "Subdued applause",
    "Swoosh ding": "Swoosh ding",
    "Synth bell": "Synth bell",
    "Taiko drum": "Taiko drum",
    "Thunder": "Thunder",
    "Ticking sound": "Ticking sound",
    "Twinkling star": "Twinkling star",
    "Water splash": "Water splash",
    "Winter holidays": "Winter holiday music",
    "Wolf howl": "Wolf howl",
    "World music": "World music",
    "Xylophone ascending": "Xylophone ascending"
  },
  "spinningwheel": {
    "Click to spin": "Click to spin",
    "Tap to spin": "Tap to spin",
    "or press ctrl+enter": "or press ctrl+enter"
  },
  "textboxbuttons": {
    "Add image": "Add image",
    "Advanced": "Advanced",
    "Revert from advanced": "Revert",
    "Reverting will reset": "If you revert from advanced mode you may lose some colors. Are you sure you want to continue?",
    "Shuffle": "Shuffle",
    "Sort": "Sort"
  },
  "toolbar": {
    "Add your language": "Add your language",
    "Dark mode": "Dark mode",
    "Exit fullscreen": "Exit fullscreen",
    "FAQ": "FAQ",
    "Feedback": "Feedback",
    "Fullscreen": "Fullscreen",
    "Language": "Language",
    "More": "More",
    "New": "New",
    "Offline mode": "Offline mode",
    "Please enter your email address": "Please enter your email address to continue",
    "Send debug data": "Send debug data",
    "Share": "Share",
    "System theme": "System theme",
    "Theme settings": "Theme settings",
    "Light theme": "Light theme",
    "Dark theme": "Dark theme",
    "Light": "Light",
    "Dark": "Dark",
    "Currently using": "Currently using",
    "Theme": "Theme",
    "Unlink Google Spreadsheet": "Unlink Google Spreadsheet",
    "User reviews and tutorials": "User reviews and tutorials",
    "Your session is now being recorded": "Your session is now being recorded. You can stop the recording by closing your browser window."
  },
  "winnerdialog": {
    "Hide": "Hide",
    "Remove": "Remove",
    "Remove all instances": "Remove all instances"
  },
  "accountdialog": {
    "Sign in intro": "Sign in to save, share, and manage your wheels.",
    "Preparing sign-in": "Preparing sign-in options…",
    "Troubleshooting title": "Troubleshooting sign-in",
    "Login failed": "Login failed. Please try again.",
    "Email verified": "Email verified",
    "Email not verified": "Email not verified",
    "Resend verification email": "Resend verification email",
    "Verification email sent": "Verification email sent. Check your inbox and spam folder.",
    "Verification email failed": "Failed to send verification email. Please try again later."
  },
  "banner": {
    "setupMessage": "Hi there! We’re still getting things set up. Some features may be limited or temporarily unavailable. Thanks for your patience!",
    "dismissLabel": "Dismiss announcement"
  }
}
